import { Component, OnInit, OnDestroy } from '@angular/core';

import { signinsService, ProjectService, LeadService, AdminService, CommonService } from '../../../_services';
import { Subscription } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-signins-list',
  templateUrl: './signins-list.component.html',
  styleUrls: ['./signins-list.component.scss']
})
export class SigninsListComponent implements OnInit {
  signins: any[];
  private subscription: Subscription
  constructor(
    private _signin : signinsService,
    private _project : ProjectService,
    private _lead: LeadService,
    private _admin: AdminService,
    private _common: CommonService,
    private _toastr : ToastrService,
  ) { }

  ngOnInit() {
    // Get Signin service...
    this.getSigninList();
  }

  getSigninList(){
    // this._common.showLoader(true);
    this.subscription = this._signin.getSigninsList().subscribe(res=>{
      // this._common.showLoader(false);
      this.signins = res;
    },err=>{
      console.log('error occured while loading signin list.');
    })
  }
  
  ngOnDestroy(){
    if(this.subscription) this.subscription.unsubscribe();
  }

  showCategoryVal(working_with_id){
    let workWithArr = [];
    if(working_with_id && working_with_id.length>0){
      const workWithList =[{id:54,name:"Architect"},{id:55,name:"Interior Designer"},{id:56,name:"General Contractor"}];
      const tempArr2 = workWithList.filter((item)=> working_with_id.includes(item.id) );
      tempArr2.forEach((item)=>{
        workWithArr.push(item.name);
      })
      return workWithArr.join(',');
    }
  }

  showSWorkingWithVal(category_id, category_other){
    let categoryArr = [];
    if(category_id && category_id !=="other"){
      const categoryList = [{id:"52",name:"Home owner"},{id:"50",name:"Realtor"},{id:"51",name:"Architect"},{id:"53",name:"Contractor"},{id:"49",name:"Interior Designer"}];
      categoryArr = categoryList.filter(item=> item.id == category_id ? item.name : '')
    }
    else if(category_id && category_id ==="other"){
      categoryArr.push({name:category_other});
    }
    return categoryArr.length >0 ? categoryArr[0].name : '';
  }

  resendEmail(obj){
    this._common.showLoader(true);
    this._project.getSystemMode().subscribe(system=>{
      const systemData = system.map(item => item.payload.doc.data());
      const baseUrlObj = systemData.filter(item=> item.hasOwnProperty("base_url"));
        // Fetch Author detail...
        this._lead.getDesignerList(obj.author_user_id).subscribe(res=>{
          const authorObj:any = res[0].payload.doc.data();
          const addedBy = authorObj.first_name +" "+ authorObj.last_name;
          // Fetch Spoke with data...
          this._lead.getDesignerList(obj.spoke_with_user_id).subscribe(res2=>{
            const spokeWithObj:any = res2[0].payload.doc.data();
            const spokeWithName = spokeWithObj.first_name +" "+ spokeWithObj.last_name;
            // Fetch Showroom data
            this._admin.getShowroomDetail(obj.showroom_id).subscribe(res=>{
              const showroomData:any = res.payload.data();


              let to;
              let cc = '';
              if(showroomData){
                if(showroomData.email_alert_sign_in_creation && showroomData.email_alert_sign_in_creation.length==1){
                  to =showroomData.join(',');
                }
                else if(showroomData.email_alert_sign_in_creation && showroomData.email_alert_sign_in_creation.length>1){
                  to =showroomData.email_alert_sign_in_creation[0];
                  let tempArr = showroomData.email_alert_sign_in_creation;
                  tempArr.shift();
                  cc = tempArr.join(',');
                }
                else {
                  to = '';
                }
              }
              
              let workWithArr:any =[];
              let categoryArr = [];
              if(obj.working_with_id && obj.working_with_id.length>0){
                const workWithList =[{id:54,name:"Architect"},{id:55,name:"Interior Designer"},{id:56,name:"General Contractor"}];
                const tempArr2 = workWithList.filter((item)=> obj.working_with_id.includes(item.id) );
                tempArr2.forEach((item)=>{
                  workWithArr.push(item.name);
                })
              }
              if(obj.category_id && obj.category_id !=="other"){
                const categoryList = [{id:"52",name:"Home owner"},{id:"50",name:"Realtor"},{id:"51",name:"Architect"},{id:"53",name:"Contractor"},{id:"49",name:"Interior Designer"}];
                categoryArr = categoryList.filter(item=> item.id == obj.category_id ? item.name : '')
              }
              else if(obj.category_id && obj.category_id ==="other"){
                categoryArr.push({name:obj.category_other});
              }
    
              //Code to send email
              let html = `<strong>Account</strong><br/>Added By: ${addedBy}<br/>Date Signed In: ${new Date(obj.date_created).toDateString()}<br/>First Name: ${obj.first_name || ''}<br/>Last Name: ${obj.last_name || ''}<br/>Email: ${obj.email || ''}<br/>Phone: ${obj.phone || ''}<br/>Mobile Phone: ${obj.phone_mobile || ''}<br/>Home Address: ${obj.home_address || ''}<br/><br/><strong>Project</strong><br/>Budget: ${obj.project_budget || ''}<br/>Appliances: ${obj.project_appliances || ''}<br/>Style/Finishes: ${obj.project_style_finishes || ''}<br/>Do you have Plan or Sketch: ${obj.have_plan_sketch || ''}<br/>Project Address: ${obj.project_address || ''}<br/>Purpose of Visit: ${obj.purpose_of_visit || ''}<br/>Notes: ${obj.notes || ''}<br/>Spoke With: ${spokeWithName}<br/>Category:${categoryArr.length >0 ? categoryArr[0].name : ''} <br/>Working With:${workWithArr.join(',')} <br/><br/>Claim: ${baseUrlObj[0]['base_url']}claim/signin/${obj.id}<br/><br/> Automated email sent via RS `;

              const mailBody = {
                to : to,
                from: 'rs@leichtnewyork.com', // from
                subject :`${showroomData.name} Walk-in: ${obj.first_name} ${obj.last_name} - ${obj.id}`,
                body : html,
                cc: cc
              }
              
              this._project.initEmail(mailBody).subscribe(res => {
                if(res){
                  this._common.showLoader(false);
                  this._toastr.success(`Mail sent Successfully!`,"",{ timeOut: 5000 });
                }
              },err=>{
                this._common.showLoader(false);
                const errMsg = err && err.message ? err.message : 'Something went wrong!';
                this._toastr.success(errMsg,"",{ timeOut: 5000 });
              }) 
            },err=>{
              this._common.showLoader(false);
              const errMsg = err && err.message ? err.message : 'Something went wrong!';
              this._toastr.success(errMsg,"",{ timeOut: 5000 });
        })

            
          },err=>{
            this._common.showLoader(false);
            const errMsg = err && err.message ? err.message : 'Something went wrong!';
            this._toastr.success(errMsg,"",{ timeOut: 5000 });
      })
            
        },err=>{
          this._common.showLoader(false);
          const errMsg = err && err.message ? err.message : 'Something went wrong!';
          this._toastr.success(errMsg,"",{ timeOut: 5000 });
        })


    },err=>{
      this._common.showLoader(false);
      const errMsg = err && err.message ? err.message : 'Something went wrong!';
      this._toastr.success(errMsg,"",{ timeOut: 5000 });
    })
  }


}
